import { CheckboxUI } from '../Interface';
import { useFormikContext } from 'formik';

const ProjectTypeUserLinks = ({ disabled }) => {
  const { values, setFieldValue } = useFormikContext();

  const updateProjectTypeUserLink = (projectTypeId, isChecked) => {
    const updatedLinks = values?.projectTypeUserLink?.map((link) =>
      link.id === projectTypeId ? { ...link, checked: isChecked } : link
    );
    setFieldValue('projectTypeUserLink', updatedLinks);
  };

  return (
    <div>
      {values?.projectTypeUserLink?.map((projectTypeLink) => (
        <div key={projectTypeLink.id}>
          <CheckboxUI
            sx={{ margin: 0, padding: '0.2rem' }}
            disabled={disabled}
            onChange={(e) => updateProjectTypeUserLink(projectTypeLink.id, e.target.checked)}
            checked={projectTypeLink.checked || false}
          />
          {projectTypeLink.name}
        </div>
      ))}
    </div>
  );
};

export default ProjectTypeUserLinks;
